var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('back',{attrs:{"history":_vm.history}}),_vm._v(" "),_c('source-group',{attrs:{"is-delete":false,"is-add":false},on:{"data-source-skip":_vm.skipTo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }